module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[5]492.b549542.woff2";